import config from "../../app.json";
import axios from "axios";

import "./series-card.scss";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import ChurchModal from "../ChurchModal";

function SeriesCard(props) {
  const {
    id,
    name,
    coverGuid,
    videoCount,
    canManage = false,
    isGeneral = false,
    onDelete,
  } = props;

  const [deleteItem, setDeleteItem] = useState({ invisible: false });

  let navigate = useNavigate();

  const setInvis = (invis) => {
    setDeleteItem({ invisible: invis });
  };

  const handleManage = (id) => {
    if (isGeneral)
      return navigate(`/videoArchive/series/general`, { replace: false });

    return navigate(`/videoArchive/series/edit/${id}`, { replace: false });
  };

  const handleRemove = (id, name) => {
    setDeleteItem({
      invisible: true,
      setInvisible: (invis) => setInvis(invis),
      title: name,
      content: `This series will be deleted permanently and its videos will be moved back to General. Confirm deletion?`,
      createItem: `Confirm`,
      discardItem: `Cancel & Close`,
      onSubmit: () => removeSeries(id),
      messageTitle: `Success`,
      message: `The Series has been successfully deleted`,
    });
  };

  const removeSeries = (id) => {
    axios.post(config.API + "/api/series/deleteSeries", { id: id }).then((res) => {
      if (onDelete)
        onDelete();

      return;
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  return (
    <div className="series-card">
      <ChurchModal {...deleteItem} />
      <div
        className={"series-card-cover" + (coverGuid ? "" : " series-card-cover-placeholder")}
        style={coverGuid ? { backgroundImage: "url(" + config.API + "/api/file/download/?guid=" + coverGuid + ")" } : {}}
      >
        {!coverGuid && <span>{name}</span>}
      </div>
      <div className="series-card-name">{name}</div>
      <div className="series-card-count">{videoCount ?? 0} {videoCount == 1 ? "video" : "videos"}</div>
      {canManage && (
        <div className="cc-card-footer">
          <Button
            className={`button-manage`}
            onClick={() => handleManage(id)}
          >
            Manage
          </Button>
          {!isGeneral && (
            <Button
              className={`button-remove`}
              onClick={() => handleRemove(id, name)}
            >
              Remove
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default SeriesCard;
